export default __webpack_public_path__ + "guide--vector-tiles-standards-wo-2-960-168c85ae6f69e1fcb03fe375577ad48d.webp";